/**
 * Product Thumbnail Navigation - Thumbnails Bottom (2 columns)
 *
 * Adds custom navigation arrows for the product image gallery when using
 * the "thumbnails_bottom_2" layout option. This layout displays 2 thumbnails
 * at a time instead of the default 4.
 *
 * @version 1.0.0
 */
(function() {
  'use strict';

  const cleanupFunctions = [];

  function initThumbnailBottom2() {
    const mediaGroups = document.querySelectorAll('[data-product-single-media-group]');

    mediaGroups.forEach(function(mediaGroup) {
      try {
        setupMediaGroup(mediaGroup);
      } catch (error) {
        console.error('Failed to initialize thumbnail navigation:', error);
      }
    });
  }

  function setupMediaGroup(mediaGroup) {
    const mainGallery = mediaGroup.querySelector('[data-main-media][data-t4s-gallery]');
    if (!mainGallery) return;

    const thumbCol = mediaGroup.parentElement.querySelector('.t4s-col-thumb');
    if (!thumbCol) return;

    const scroller = thumbCol.querySelector('[data-thumb__scroller]');
    if (!scroller) return;

    const carouselNav = scroller.querySelector('[class*="carousel__nav"]');
    if (!carouselNav) return;

    const isThumbnailBottom2 = carouselNav.classList.contains('t4s-row-cols-2');
    if (!isThumbnailBottom2) return;

    if (scroller.hasAttribute('data-thumb-bottom2-fixed')) return;
    scroller.setAttribute('data-thumb-bottom2-fixed', 'true');

    waitForFlickity(mainGallery, function() {
      setupCustomArrows(mainGallery, scroller, carouselNav);
    });
  }

  function waitForFlickity(mainGallery, callback) {
    let attempts = 0;
    const maxAttempts = 50;

    const checkInterval = setInterval(function() {
      attempts++;

      const flickityPrevBtn = mainGallery.querySelector('.flickityt4s-prev-next-button.previous');
      const flickityNextBtn = mainGallery.querySelector('.flickityt4s-prev-next-button.next');

      if (flickityPrevBtn && flickityNextBtn) {
        clearInterval(checkInterval);
        callback();
      } else if (attempts >= maxAttempts) {
        clearInterval(checkInterval);
        console.warn('Flickity initialization timeout - using default navigation');
      }
    }, 100);
  }

  function setupCustomArrows(mainGallery, scroller, carouselNav) {
    const flickityPrevBtn = mainGallery.querySelector('.flickityt4s-prev-next-button.previous');
    const flickityNextBtn = mainGallery.querySelector('.flickityt4s-prev-next-button.next');

    if (!flickityPrevBtn || !flickityNextBtn) return;

    flickityPrevBtn.style.display = 'none';
    flickityNextBtn.style.display = 'none';

    const customPrevBtn = document.createElement('button');
    customPrevBtn.className = 'flickityt4s-button flickityt4s-prev-next-button previous t4s-thumb-custom-arrow';
    customPrevBtn.type = 'button';
    customPrevBtn.setAttribute('aria-label', 'Previous');
    customPrevBtn.innerHTML = '<svg class="flickityt4s-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>';

    const customNextBtn = document.createElement('button');
    customNextBtn.className = 'flickityt4s-button flickityt4s-prev-next-button next t4s-thumb-custom-arrow';
    customNextBtn.type = 'button';
    customNextBtn.setAttribute('aria-label', 'Next');
    customNextBtn.innerHTML = '<svg class="flickityt4s-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180)"></path></svg>';

    const thumbColParent = scroller.parentElement;
    if (!thumbColParent) return;

    thumbColParent.style.position = 'relative';
    thumbColParent.appendChild(customPrevBtn);
    thumbColParent.appendChild(customNextBtn);

    const thumbItem = carouselNav.querySelector('.t4s-col-item');
    const scrollDistance = thumbItem ? thumbItem.offsetWidth : scroller.offsetWidth * 0.5;

    const controller = new AbortController();
    const signal = controller.signal;

    customPrevBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const currentScroll = scroller.scrollLeft;

      if ('scrollBehavior' in document.documentElement.style) {
        scroller.scrollTo({
          left: Math.max(0, currentScroll - scrollDistance),
          behavior: 'smooth'
        });
      } else {
        scroller.scrollLeft = Math.max(0, currentScroll - scrollDistance);
      }
    }, { signal: signal });

    customNextBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const currentScroll = scroller.scrollLeft;
      const maxScroll = carouselNav.scrollWidth - scroller.offsetWidth;

      if ('scrollBehavior' in document.documentElement.style) {
        scroller.scrollTo({
          left: Math.min(maxScroll, currentScroll + scrollDistance),
          behavior: 'smooth'
        });
      } else {
        scroller.scrollLeft = Math.min(maxScroll, currentScroll + scrollDistance);
      }
    }, { signal: signal });

    function updateButtonState() {
      const currentScroll = scroller.scrollLeft;
      const maxScroll = carouselNav.scrollWidth - scroller.offsetWidth;

      if (currentScroll <= 5) {
        customPrevBtn.setAttribute('disabled', 'disabled');
      } else {
        customPrevBtn.removeAttribute('disabled');
      }

      if (currentScroll >= maxScroll - 5) {
        customNextBtn.setAttribute('disabled', 'disabled');
      } else {
        customNextBtn.removeAttribute('disabled');
      }
    }

    scroller.addEventListener('scroll', updateButtonState, { signal: signal });
    window.addEventListener('resize', updateButtonState, { signal: signal });

    updateButtonState();

    cleanupFunctions.push(function() {
      controller.abort();
      if (customPrevBtn.parentNode) customPrevBtn.parentNode.removeChild(customPrevBtn);
      if (customNextBtn.parentNode) customNextBtn.parentNode.removeChild(customNextBtn);
    });
  }

  function cleanup() {
    cleanupFunctions.forEach(function(fn) {
      try {
        fn();
      } catch (error) {
        console.error('Cleanup error:', error);
      }
    });
    cleanupFunctions.length = 0;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initThumbnailBottom2);
  } else {
    initThumbnailBottom2();
  }

  if (window.Shopify) {
    window.Shopify.thumbnailNavCleanup = cleanup;
  }

})();
